@if (withFilter && !withDragDrop) {
  <mat-form-field class="width100procent rahmen filtertextbox">
    <mat-label>Filter</mat-label>
    <mat-icon matPrefix>filter_alt</mat-icon>
    <input matInput (keyup)="applyFilter($event)" placeholder="Filterwert" #filterElement>
    @if (filterElement.value) {
      <button matSuffix mat-icon-button aria-label="Clear"
        (click)="clearFilter(filterElement)">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
}

<div #tableVisibility class="table-container mat-elevation-z2">
  @if (isLoading===true) {
    <div class="spinner-container">
      <mat-progress-spinner color="primary" mode="indeterminate" diameter="50">
      </mat-progress-spinner>
    </div>
  }
  @if (dataSource) {
    <mat-table #table [dataSource]="dataSource" [style.max-height]="maxHeight"
      [style.min-height]="maxHeight" [style.overflow]="(maxHeight) ? 'auto' : ''" matSort
      cdkDropList (cdkDropListDropped)="dropRow($event)">
      <!-- Row shown when there is no matching data. -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">Keine Daten verfügbar.</td>
      </tr>
      @if (withDragDrop) {
        <ng-container matColumnDef="drag">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let row; let rowIndex = dataIndex">
            <mat-icon cdkDragHandle class="drag-handle">drag_indicator</mat-icon>
          </mat-cell>
        </ng-container>
      }
      @if (withSelection) {
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? toggleAllRows() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row; let rowIndex = dataIndex">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? toggleRow(row) : null"
              [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
            </mat-checkbox>
          </mat-cell>
        </ng-container>
      }
      @if (columns) {
        @for (column of columns; track column) {
          <!-- Key Column -->
          <ng-container [matColumnDef]="column.dataStoreKey">
            <mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="withDragDrop">
              @if (column.icon) {
                <mat-icon>{{column.icon}}</mat-icon>
              }
              {{column.headerTitle}}
            </mat-header-cell>
            <mat-cell *matCellDef="let row; let rowIndex = index">
              @if (!column.type || column.type.toLowerCase() === 'text') {
                {{row[column.dataStoreKey]}}
              }
              @if (column?.type?.toLowerCase() === 'icon') {
                <mat-icon>{{row[column.dataStoreKey]}}</mat-icon>
              }
              @if (column?.type?.toLowerCase() === 'dropdown') {
                <div class="div-drop-down">
                  <mat-select #select (ngModelChange)="onDropDownModelChange($event, column, row, rowIndex)"
                    [ngModel]="row[column.dataStoreKey]">
                    @if(column.dropDown?.withEmptyFirstLine) {
                      <mat-option [value]="">
                      </mat-option>
                    }
                    @for (item of (column.dropDown.dataStore$ | async); track $index) {
                      @if(IsDropDownItemVisible(column, item, row)) {
                        <mat-option [value]="item[column.dropDown.dataStoreKeyForValue]">
                          {{item[column.dropDown.dataStoreKeyForDisplay]}}
                        </mat-option>
                      }
                    }
                  </mat-select>
                </div>
              }
            </mat-cell>
          </ng-container>
        }
      }
      @if (withOperation) {
        <ng-container matColumnDef="operation">
          <mat-header-cell *matHeaderCellDef>
            @if (withOperation) {
              <mat-icon fontIcon="build" color="primary">
              </mat-icon>
            }
          </mat-header-cell>
          <mat-cell *matCellDef="let row; let rowIndex = index">
            @if (row.operation === 'add') {
              <mat-icon fontIcon="add" color="success">
              </mat-icon>
            }
            @if (row.operation === 'remove') {
              <mat-icon fontIcon="remove" color="warn">
              </mat-icon>
            }
            @if (row.operation === 'update') {
              <mat-icon fontIcon="sync" color="primary">
              </mat-icon>
            }
          </mat-cell>
        </ng-container>
      }
      @if (withRemove) {
        <ng-container matColumnDef="remove">
          <mat-header-cell *matHeaderCellDef>
            @if (withAllRemove) {
              <mat-icon (click)="removeAll(); $event.stopPropagation();"
                fontIcon="delete_forever" color="primary">
              </mat-icon>
            }
          </mat-header-cell>
          <mat-cell *matCellDef="let row; let rowIndex = index">
            <mat-icon (click)="removeRow(row, rowIndex); $event.stopPropagation();" fontIcon="delete" color="primary">
            </mat-icon>
          </mat-cell>
        </ng-container>
      }
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"
        cdkDrag [cdkDragDisabled]="!withDragDrop"
        [ngClass]="{ 'selected' : selection.isSelected(row), 'add' : row.operation === 'add', 'remove' : row.operation === 'remove', 'update' : row.operation === 'update' }"
        (click)="toggleRow(row)">
      </mat-row>
    </mat-table>
  }

  @if (withPagination) {
    <mat-paginator [pageSize]="paginatorPageSize" [pageSizeOptions]="paginatorPageSizeOptions"
      showFirstLastButtons aria-label="Select page of periodic elements">
    </mat-paginator>
  }
</div>
